import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import CategoryForm, { CategoryFormData } from "../../../components/store/category/CategoryForm";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";

export default function CreateCategoryPage() {
  const { storeId} = useParams<{ storeId: string}>();
  const numericStoreId = storeId ? parseInt(storeId) : undefined;

  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<CategoryFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });

   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: CategoryFormData) => {
    // call API to create category
    const endPoint = storeId ? `category/create?storeId=${numericStoreId}`: `category/create`;
    updateResource(endPoint, data, storeId? "admin":"store",{
            method: "POST",
            successMessage: t("store_created_success"),
            invalidateQueries:["product-categories-for-action","product-categories"],
            navigateAfter: () => navigate(-1),
          });
  };

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="create_category" />
        <CategoryForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
